import type { Observable } from 'rxjs/Observable';
import { fetchJson$ } from '@atlassian/jira-fetch';
import type { CurrentUserResponse } from './types';

export const getCurrentUser$ = (): Observable<CurrentUserResponse> =>
	fetchJson$('/rest/api/3/myself', {
		method: 'GET',
	});
